// Централизованный словарь строк UI. Хранение выбранного языка — localStorage.
// Смена языка перезагружает страницу, поэтому все `import { t }` продолжают работать без ref-hooks.

const ru = {
  nav: {
    dashboard: "Дашборд",
    devices: "Устройства",
    accounts: "Аккаунты",
    personas: "Персоны",
    proxies: "Прокси",
    videos: "Видео",
    schedule: "Расписание",
    streams: "Стримы",
    warmup: "Прогрев",
    comments: "Комментарии",
    logs: "Логи",
    analytics: "Аналитика",
    alerts: "Алерты",
    settings: "Настройки",
    logout: "Выйти",
    brand: "ТТ-Помощник",
    brandTag: "Админка",
  },
  common: {
    loading: "Загрузка…",
    save: "Сохранить",
    saveChanges: "Сохранить изменения",
    cancel: "Отмена",
    delete: "Удалить",
    confirmDelete: "Точно удалить?",
    add: "Добавить",
    edit: "Изменить",
    close: "Закрыть",
    refresh: "Обновить",
    yes: "Да",
    no: "Нет",
    none: "—",
    unlinked: "— не привязано —",
    optional: "необязательно",
    search: "Поиск",
    all: "все",
    open: "Открыть",
    apply: "Применить",
    generate: "Сгенерировать",
    generating: "Генерирую…",
    saved: "Сохранено",
    saveFailed: "Не удалось сохранить",
    deleted: "Удалено",
    failed: "Ошибка",
    selected: (n) => `Выбрано: ${n}`,
    selectAll: "Выбрать всё",
    clearSelection: "Снять выделение",
    live: "Live",
  },
  login: {
    title: "Введите PIN",
    subtitle: "Разблокируйте панель",
    wrongPin: "Неверный PIN",
    checking: "Проверяю…",
    unlock: "Войти",
    hint: "PIN хранится в переменной ADMIN_PIN на сервере",
    welcome: "С возвращением",
  },
  dashboard: {
    title: "Командный центр",
    description: "Ваш флот на одном экране — устройства, прогресс прогрева и сегодняшняя динамика.",
    seed: "Заполнить демо-данными",
    seeding: "Заполняю…",
    kpi: {
      devices_online: "Телефоны онлайн",
      accounts_total: "Аккаунты",
      videos_queued: "Видео в очереди",
      alerts_unack: "Открытые алерты",
      total_followers: "Всего подписчиков",
      views_estimated_7d: "Просмотров ≈ 7д",
      avg_health_score: "Средний health",
    },
    momentum: "Динамика · 14 дней",
    momentumSub: "Приблизительные просмотры, лайки и подписки по всему флоту",
    phones: "Ваши телефоны",
    phonesSub: "Статус каждого подключённого iPhone в реальном времени.",
    noDevices: "Телефонов пока нет",
    noDevicesHint: "Заполни демо-данные или добавь первый iPhone на странице Устройства.",
    liveFeed: "Лента событий · live",
    liveFeedSub: "Что делают телефоны прямо сейчас — обновление каждые несколько секунд.",
    liveFeedEmpty: "Пока тихо — событий нет.",
  },
  devices: {
    title: "Устройства и аккаунты",
    description: "Физический iPhone ↔ прокси ↔ TikTok-аккаунт ↔ персона. Один телефон — один аккаунт.",
    addDevice: "Добавить телефон",
    editDevice: "Редактировать телефон",
    newDevice: "Новый iPhone",
    empty: "Устройств пока нет",
    emptyHint: "Добавь свой первый iPhone кнопкой выше.",
    ping: "Пинг",
    linkAccount: "Привязать аккаунт",
    linkProxy: "Привязать прокси",
    fields: {
      name: "Название",
      model: "Модель",
      color: "Цвет",
      ios: "Версия iOS",
      udid: "UDID",
      battery: "Батарея, %",
      imageUrl: "URL картинки",
      status: "Статус",
      account: "Аккаунт",
      persona: "Персона",
      proxy: "Прокси",
      device: "Устройство",
    },
    status: {
      idle: "простаивает",
      warming: "прогревается",
      posting: "постит",
      watching_stream: "смотрит стрим",
      commenting: "комментирует",
      sleeping: "спит по гео",
      alert: "алерт",
      offline: "офлайн",
    },
    pinged: "Пинг отправлен",
  },
  accounts: {
    title: "TikTok-аккаунты",
    description: "Каждый аккаунт связан с одной персоной, одним телефоном и одним прокси.",
    add: "Добавить аккаунт",
    edit: "Редактировать аккаунт",
    empty: "Пока нет аккаунтов",
    emptyHint: "Добавь первый — начнём прогрев.",
    reanimate: "Оживить (сброс в прогрев)",
    reanimateConfirm: "Сбросить аккаунт в прогрев (день 1)?",
    reanimated: "Аккаунт сброшен в прогрев (день 1)",
    bulk: {
      title: "Массовые действия",
      pickOp: "Выбери действие",
      apply: "Применить ко всем",
      confirm: (n, op) => `Применить «${op}» к ${n} аккаунту(ам)?`,
      done: (n, op) => `«${op}» выполнено для ${n} аккаунта(ов)`,
      operations: {
        reanimate: "Оживить (сброс в прогрев)",
        pause: "Поставить на паузу",
        resume: "Возобновить",
        advance_day: "+1 день прогрева",
        delete: "Удалить",
      },
    },
    fields: {
      username: "Username (@…)",
      tiktokUrl: "URL профиля в TikTok",
      device: "Устройство",
      persona: "Персона",
      proxy: "Прокси",
      timezone: "Часовой пояс (IANA)",
      stage: "Стадия",
      warmupDay: "День прогрева",
      followers: "Подписчиков",
      following: "Подписок",
      likes: "Всего лайков",
      videosPosted: "Видео опубликовано",
      health: "Health",
    },
    timezoneHint: "например America/New_York. Пусто — используем гео персоны.",
    timezoneAuto: "по гео персоны",
    timeline: "Лента",
    timelineTitle: (u) => `Лента · ${u}`,
    timelineEmpty: "Событий пока нет.",
    timelineRecent: "Недавние действия",
    timelineUpcoming: "Ближайшие задачи",
    timelinePlanned: "запланировано",
    timelineWarmup: "прогрев",
    timelineSchedule: "публикация",
    stage: {
      warmup: "прогрев",
      active: "активный",
      paused: "на паузе",
      banned: "забанен",
      shadowbanned: "теневой бан",
    },
    aiAdvice: "Совет от ИИ",
    aiAdviceLoading: "ИИ анализирует…",
    aiAdviceTitle: (u) => `Совет по @${u}`,
    aiAdviceSummary: "Резюме",
    aiAdviceTips: "Что сделать",
    aiAdviceRisk: "Риск",
    aiAdviceRisk_low: "низкий",
    aiAdviceRisk_medium: "средний",
    aiAdviceRisk_high: "высокий",
    aiAdviceFailed: "Не удалось получить совет",
  },
  personas: {
    title: "Персоны",
    description: "У каждого аккаунта — своя душа. ИИ рисует, ты одобряешь.",
    new: "Новая персона",
    edit: "Редактировать персону",
    aiWizard: "ИИ-мастер",
    empty: "Персон пока нет",
    emptyHint: "Создай первую — ИИ соберёт её за секунду.",
    approve: "Одобрить и сохранить",
    generate: "Сгенерировать через Claude",
    approved: "одобрена",
    saved: "Персона сохранена",
    fields: {
      name: "Имя",
      age: "Возраст",
      gender: "Пол",
      geo: "Гео",
      language: "Язык",
      interests: "Интересы (через запятую)",
      bio: "Био",
      tone: "Тон / голос",
      rhythm: "Суточный ритм",
      quirks: "Особенности (через запятую)",
      avatarUrl: "URL аватара",
      notes: "Заметки для ИИ",
    },
    rhythm: { night_owl: "сова", early_bird: "жаворонок", balanced: "смешанный" },
    gender: { female: "женский", male: "мужской", "non-binary": "небинарный" },
    aiRefresh: "Освежить био от ИИ",
    aiRefreshing: "ИИ пишет…",
    aiRefreshDone: "Био обновлено",
    aiRefreshFailed: "Не удалось обновить био",
  },
  proxies: {
    title: "Прокси",
    description: "Мобильные и резидентные прокси на каждый аккаунт.",
    add: "Добавить прокси",
    edit: "Редактировать прокси",
    check: "Проверить",
    empty: "Прокси пока нет",
    healthy: "живой",
    dead: "мёртвый",
    fields: {
      provider: "Провайдер",
      type: "Тип",
      geo: "Гео",
      host: "Host",
      label: "Метка",
      healthy: "Живой?",
    },
    type: { mobile: "мобильный", residential: "резидентный", esim: "eSIM" },
  },
  videos: {
    title: "Библиотека видео",
    description: "Загружайте mp4/mov прямо сюда. ИИ пишет описание, подбирает хэштеги и трендовый звук.",
    add: "Добавить вручную",
    edit: "Редактировать видео",
    empty: "Видео пока нет",
    emptyHint: "Загрузи первое видео кнопкой выше.",
    aiDraft: "Черновик через ИИ",
    aiDone: "Описание готово",
    queue: "В очередь",
    unqueue: "Убрать из очереди",
    play: "Просмотр",
    upload: "Загрузить видео",
    uploading: "Загрузка…",
    uploadDone: (name) => `«${name}» загружено`,
    uploadFailed: "Не удалось загрузить видео",
    noFile: "У этого видео нет загруженного файла",
    fileHere: "Файл сохранён у нас",
    bulk: {
      trigger: "Массовая загрузка",
      title: "Массовая загрузка видео",
      description: "Перетащи файлы сюда или выбери сразу несколько — загрузим по очереди.",
      dropHere: "Перетащи видео сюда",
      dropSub: "или нажми, чтобы выбрать файлы",
      pickFiles: "Выбрать файлы",
      account: "Аккаунт для всей пачки",
      accountHint: "Применится ко всем загруженным файлам. Можно оставить пустым.",
      caption: "Общее описание (необязательно)",
      start: "Начать загрузку",
      close: "Закрыть",
      clear: "Очистить список",
      summary: (done, failed, total) => `Готово: ${done} · ошибок: ${failed} · всего: ${total}`,
      empty: "Пока не добавлено ни одного файла.",
      statusPending: "в очереди",
      statusUploading: "загружается",
      statusDone: "готово",
      statusError: "ошибка",
      remove: "Убрать",
      allDone: (n) => `Загружено ${n} видео`,
      partial: (done, failed) => `Загружено ${done}, с ошибками: ${failed}`,
      allFailed: "Не удалось загрузить ни одного файла",
      running: "Загружаю…",
    },
    ideas: {
      trigger: "Идеи от ИИ",
      title: "ИИ-идеи роликов",
      description: "ИИ подбирает идеи под персону выбранного аккаунта — hook, длительность и подсказку по звуку.",
      account: "Аккаунт (для персоны)",
      accountAny: "Без привязки — общий стиль",
      generate: "Сгенерировать идеи",
      generating: "ИИ думает…",
      empty: "Пока идей нет — нажми «Сгенерировать».",
      close: "Закрыть",
      use: "Создать черновик",
      used: "Черновик создан",
      failed: "Не удалось получить идеи от ИИ",
      hook: "Хук",
      caption: "Описание",
      hashtags: "Хэштеги",
      duration: "Длительность",
      sound: "Звук",
      seconds: (s) => `${s}с`,
    },
    fields: {
      filename: "Имя файла",
      sizeMb: "Размер, МБ",
      duration: "Длительность, с",
      thumbnail: "URL превью",
      caption: "Описание",
      hashtags: "Хэштеги (через запятую)",
      sound: "Трендовый звук",
      account: "Аккаунт-получатель",
    },
  },
  schedule: {
    title: "Расписание",
    description: "Когда и где выйдет каждый ролик. Подсказки лучшего времени по гео уже работают.",
    add: "Запланировать пост",
    edit: "Изменить пост",
    empty: "Ничего не запланировано",
    emptyHint: "Поставь пост в очередь — увидишь его тут.",
    markDone: "Отметить как опубликовано",
    marked: "Пост отмечен как опубликован",
    bestTimes: "Лучшее время для этого аккаунта",
    bestTimesPickAccount: "Выбери аккаунт — покажу рекомендованные слоты.",
    reasons: {
      "morning scroll": "утренний скролл",
      "lunch break": "обеденный перерыв",
      "commute home": "дорога домой",
      "prime-time couch": "прайм-тайм на диване",
      "off-peak but persona-matched": "вне пика, но по персоне",
    },
    fields: { video: "Видео", account: "Аккаунт", device: "Устройство", when: "Когда" },
    status: { planned: "запланировано", running: "выполняется", done: "готово", failed: "провал" },
  },
  streams: {
    title: "Стрим-буст",
    description: "Кидаешь ссылку — аккаунты находят её через поиск или ленту, а не по прямой. Смотрят по-человечески.",
    add: "Новая задача",
    edit: "Изменить задачу",
    empty: "Задач пока нет",
    emptyHint: "Создай первую — выбери аккаунты, задай рандом.",
    create: "Создать задачу",
    start: "Запустить",
    stop: "Остановить",
    fields: {
      url: "URL стрима",
      keywords: "Ключевики (через запятую)",
      approach: "Способ поиска",
      minWatch: "Минимум смотреть, мин",
      maxWatch: "Максимум смотреть, мин",
      likeProb: "Вероятность лайка",
      commentProb: "Вероятность комментария",
      accounts: "Аккаунты-исполнители",
    },
    approach: { search: "Поиск", for_you: "Рекомендации", mixed: "Смешанно (рекомендуется)" },
  },
  warmup: {
    title: "Прогрев",
    description:
      "Каждому аккаунту — свой суточный план. Учитываем персону, ритм и «тихие часы» по гео. С 1-го по 7-й день интенсивность растёт.",
    tick: "Прогнать 60 мин",
    ticking: "Выполняю…",
    empty: "Аккаунтов для прогрева нет",
    emptyHint: "Добавь аккаунт и привяжи персону.",
    day: "День",
    plan: "План",
    todaysPlan: "План на сегодня",
    counters: { planned: "план", done: "готово", skipped: "пропуск" },
    regen: "Пересобрать план",
    regenerated: "План пересобран",
    advance: "Следующий день",
    advancedTo: (day, active) => `Теперь день ${day}${active ? " · переведён в АКТИВНЫЙ 🎉" : ""}`,
    executed: (n, accs) => `Выполнено ${n} действий на ${accs} аккаунтах`,
    todayProgress: "Прогресс сегодня",
    next: (action, time) => `следующее ${action} в ${time}`,
    actionStatus: { planned: "в плане", done: "готово", skipped: "пропуск" },
    markDone: "Отметить готовым",
    skip: "Пропустить",
    deleted: "Действие удалено",
  },
  comments: {
    title: "Автокомментарии",
    description: "Кидаешь ссылку → Claude пишет один персона-стилизованный комментарий на аккаунт и раздаёт их во времени.",
    new: "Новая рассылка",
    postDue: "Опубликовать готовые",
    posting: "Публикую…",
    empty: "Очередь пуста",
    emptyHint: "Создай первую рассылку, чтобы посеять первое взаимодействие.",
    create: "Создать и поставить в очередь",
    creating: "Генерирую…",
    fields: { url: "URL видео-цели", topic: "О чём видео (для ИИ)", spread: "Разбросать, минут", accounts: "Аккаунты" },
    queued: (n) => `${n} ИИ-комментариев в очереди`,
    posted: (n) => `Опубликовано (мок): ${n}`,
    status: { planned: "в плане", posted: "опубликован", skipped: "пропуск" },
  },
  logs: {
    title: "Логи действий",
    description: "Каждый свайп, лайк, подписка, комментарий и пауза — со временем и связью.",
    filter: { all: "все", info: "инфо", success: "успех", warn: "варнинг", error: "ошибка" },
    empty: "Логов нет",
  },
  analytics: {
    title: "Аналитика",
    description: "Куда движется флот. Health-скор, рост подписчиков, риск теневого бана.",
    growth30d: "Рост флота · 30 дней",
    perAccountHealth: "Health по аккаунтам",
    shadowRisk: "Риск теневого бана",
    noAccounts: "Аккаунтов пока нет",
    risk: { low: "низкий", medium: "средний", high: "высокий" },
  },
  alerts: {
    title: "Алерты",
    description: "Капчи, баны, отвалившиеся телефоны — всё, что требует человека.",
    empty: "Всё чисто",
    emptyHint: "Открытых алертов нет. Отдыхаем.",
    ack: "Принято",
    acknowledged: "принято",
    resolveCaptcha: "Капча решена",
    captchaResolved: "Капча закрыта, устройство разбужено",
    severity: { low: "низкая", medium: "средняя", high: "высокая", critical: "критично" },
    type: {
      captcha: "капча",
      ban: "бан",
      shadowban: "теневой бан",
      device_offline: "устройство офлайн",
      task_failed: "задача упала",
      warning: "предупреждение",
    },
  },
  settings: {
    title: "Настройки",
    description: "Провайдеры, бюджет, тихие часы и проверка ИИ.",
    save: "Сохранить",
    aiModels: "ИИ-модели",
    antidetect: "Антидетект по умолчанию",
    macAgents: "Mac-агенты",
    session: "Сессия",
    noAgents: "Mac-агент пока не подключён.",
    agentHint:
      "Возьми скелет из /app/mac-agent/, укажи BACKEND_URL и PIN, запусти python agent.py.",
    testAi: "Проверить связь с ИИ",
    pinging: "Проверяю…",
    aiOk: (model, resp) => `OK — ${model} ответил "${resp}"`,
    aiError: (err) => `ОШИБКА — ${err}`,
    fields: {
      aiProvider: "Провайдер ИИ",
      claudeModel: "Модель Claude",
      geminiModel: "Модель Gemini",
      budget: "Бюджет, $/мес",
      proxy: "Провайдер прокси",
      geo: "Гео по умолчанию",
      quietStart: "Тихие часы: начало (ч)",
      quietEnd: "Тихие часы: конец (ч)",
    },
    sessionText: (envKey) =>
      `PIN админа берётся из переменной среды ${envKey} на бекенде. Чтобы сменить — обнови .env и перезапусти бекенд.`,
    lastSeen: "видели",
    devicesCount: (n) => `${n} устр.`,
  },
  geoOptions: { US: "США", UK: "Великобритания" },
  languageOptions: { "en-US": "английский (US)", "en-GB": "английский (UK)" },
};

const en = {
  nav: {
    dashboard: "Dashboard",
    devices: "Devices",
    accounts: "Accounts",
    personas: "Personas",
    proxies: "Proxies",
    videos: "Videos",
    schedule: "Schedule",
    streams: "Streams",
    warmup: "Warm-up",
    comments: "Comments",
    logs: "Logs",
    analytics: "Analytics",
    alerts: "Alerts",
    settings: "Settings",
    logout: "Log out",
    brand: "TT Growth",
    brandTag: "Admin",
  },
  common: {
    loading: "Loading…",
    save: "Save",
    saveChanges: "Save changes",
    cancel: "Cancel",
    delete: "Delete",
    confirmDelete: "Delete for sure?",
    add: "Add",
    edit: "Edit",
    close: "Close",
    refresh: "Refresh",
    yes: "Yes",
    no: "No",
    none: "—",
    unlinked: "— unlinked —",
    optional: "optional",
    search: "Search",
    all: "all",
    open: "Open",
    apply: "Apply",
    generate: "Generate",
    generating: "Generating…",
    saved: "Saved",
    saveFailed: "Save failed",
    deleted: "Deleted",
    failed: "Failed",
    selected: (n) => `Selected: ${n}`,
    selectAll: "Select all",
    clearSelection: "Clear selection",
    live: "Live",
  },
  login: {
    title: "Enter PIN",
    subtitle: "Unlock the console",
    wrongPin: "Wrong PIN",
    checking: "Checking…",
    unlock: "Unlock",
    hint: "PIN is stored in ADMIN_PIN on the server",
    welcome: "Welcome back",
  },
  dashboard: {
    title: "Command Center",
    description: "Your fleet at a glance — devices, warm-up progress, and today's momentum.",
    seed: "Seed demo data",
    seeding: "Seeding…",
    kpi: {
      devices_online: "Phones online",
      accounts_total: "Accounts",
      videos_queued: "Videos queued",
      alerts_unack: "Open alerts",
      total_followers: "Total followers",
      views_estimated_7d: "Est. views 7d",
      avg_health_score: "Avg. health",
    },
    momentum: "Momentum · 14d",
    momentumSub: "Estimated views, likes, follows across the fleet",
    phones: "Your phones",
    phonesSub: "Real-time status of each connected iPhone.",
    noDevices: "No devices yet",
    noDevicesHint: "Seed demo data or add your first iPhone on Devices.",
    liveFeed: "Live event feed",
    liveFeedSub: "What phones are doing right now — refreshes every few seconds.",
    liveFeedEmpty: "Quiet — no events yet.",
  },
  devices: {
    title: "Devices & Accounts",
    description: "Physical iPhone ↔ Proxy ↔ TikTok Account ↔ Persona. One phone, one account.",
    addDevice: "Add device",
    editDevice: "Edit device",
    newDevice: "New iPhone",
    empty: "No devices yet",
    emptyHint: "Add your first iPhone with the button above.",
    ping: "Ping",
    linkAccount: "Link account",
    linkProxy: "Link proxy",
    fields: {
      name: "Name",
      model: "Model",
      color: "Color",
      ios: "iOS version",
      udid: "UDID",
      battery: "Battery, %",
      imageUrl: "Image URL",
      status: "Status",
      account: "Account",
      persona: "Persona",
      proxy: "Proxy",
      device: "Device",
    },
    status: {
      idle: "idle",
      warming: "warming up",
      posting: "posting",
      watching_stream: "watching stream",
      commenting: "commenting",
      sleeping: "quiet hours",
      alert: "alert",
      offline: "offline",
    },
    pinged: "Ping sent",
  },
  accounts: {
    title: "TikTok accounts",
    description: "Every account is tied to one persona, one phone, and one proxy.",
    add: "Add account",
    edit: "Edit account",
    empty: "No accounts yet",
    emptyHint: "Add the first one — warm-up begins.",
    reanimate: "Reanimate (reset to warm-up)",
    reanimateConfirm: "Reset this account to warm-up day 1?",
    reanimated: "Account reset to warm-up day 1",
    bulk: {
      title: "Bulk actions",
      pickOp: "Choose action",
      apply: "Apply to selected",
      confirm: (n, op) => `Apply "${op}" to ${n} account(s)?`,
      done: (n, op) => `"${op}" applied to ${n} account(s)`,
      operations: {
        reanimate: "Reanimate (reset)",
        pause: "Pause",
        resume: "Resume",
        advance_day: "+1 warm-up day",
        delete: "Delete",
      },
    },
    fields: {
      username: "Username (@…)",
      tiktokUrl: "TikTok profile URL",
      device: "Device",
      persona: "Persona",
      proxy: "Proxy",
      timezone: "Time zone (IANA)",
      stage: "Stage",
      warmupDay: "Warm-up day",
      followers: "Followers",
      following: "Following",
      likes: "Total likes",
      videosPosted: "Videos posted",
      health: "Health",
    },
    timezoneHint: "e.g. America/New_York. Empty — uses persona geo.",
    timezoneAuto: "persona geo",
    timeline: "Timeline",
    timelineTitle: (u) => `Timeline · ${u}`,
    timelineEmpty: "No events yet.",
    timelineRecent: "Recent actions",
    timelineUpcoming: "Upcoming tasks",
    timelinePlanned: "planned",
    timelineWarmup: "warmup",
    timelineSchedule: "post",
    stage: {
      warmup: "warmup",
      active: "active",
      paused: "paused",
      banned: "banned",
      shadowbanned: "shadowban",
    },
    aiAdvice: "AI advice",
    aiAdviceLoading: "AI analysing…",
    aiAdviceTitle: (u) => `Advice for @${u}`,
    aiAdviceSummary: "Summary",
    aiAdviceTips: "Do this",
    aiAdviceRisk: "Risk",
    aiAdviceRisk_low: "low",
    aiAdviceRisk_medium: "medium",
    aiAdviceRisk_high: "high",
    aiAdviceFailed: "Advice failed",
  },
  personas: {
    title: "Personas",
    description: "Every account has a soul. AI drafts, you approve.",
    new: "New persona",
    edit: "Edit persona",
    aiWizard: "AI wizard",
    empty: "No personas yet",
    emptyHint: "Create the first one — AI does it in a second.",
    approve: "Approve & save",
    generate: "Generate with Claude",
    approved: "approved",
    saved: "Persona saved",
    fields: {
      name: "Name",
      age: "Age",
      gender: "Gender",
      geo: "Geo",
      language: "Language",
      interests: "Interests (comma-separated)",
      bio: "Bio",
      tone: "Tone / voice",
      rhythm: "Daily rhythm",
      quirks: "Quirks (comma-separated)",
      avatarUrl: "Avatar URL",
      notes: "Notes for AI",
    },
    rhythm: { night_owl: "night owl", early_bird: "early bird", balanced: "balanced" },
    gender: { female: "female", male: "male", "non-binary": "non-binary" },
    aiRefresh: "Refresh bio with AI",
    aiRefreshing: "AI writing…",
    aiRefreshDone: "Bio updated",
    aiRefreshFailed: "Bio refresh failed",
  },
  proxies: {
    title: "Proxies",
    description: "Mobile and residential proxies for each account.",
    add: "Add proxy",
    edit: "Edit proxy",
    check: "Check",
    empty: "No proxies yet",
    healthy: "healthy",
    dead: "dead",
    fields: {
      provider: "Provider",
      type: "Type",
      geo: "Geo",
      host: "Host",
      label: "Label",
      healthy: "Healthy?",
    },
    type: { mobile: "mobile", residential: "residential", esim: "eSIM" },
  },
  videos: {
    title: "Video Library",
    description: "Upload mp4/mov right here. AI drafts caption, hashtags and picks a trending sound.",
    add: "Add manually",
    edit: "Edit video",
    empty: "No videos yet",
    emptyHint: "Upload your first video with the button above.",
    aiDraft: "Draft with AI",
    aiDone: "Caption ready",
    queue: "Queue",
    unqueue: "Unqueue",
    play: "Preview",
    upload: "Upload video",
    uploading: "Uploading…",
    uploadDone: (name) => `"${name}" uploaded`,
    uploadFailed: "Video upload failed",
    noFile: "No file uploaded for this video",
    fileHere: "File stored on our server",
    bulk: {
      trigger: "Bulk upload",
      title: "Bulk video upload",
      description: "Drop files here or pick several at once — we'll upload them one by one.",
      dropHere: "Drop videos here",
      dropSub: "or click to pick files",
      pickFiles: "Pick files",
      account: "Target account for the batch",
      accountHint: "Applied to every uploaded file. Can be left empty.",
      caption: "Shared caption (optional)",
      start: "Start upload",
      close: "Close",
      clear: "Clear list",
      summary: (done, failed, total) => `Done: ${done} · errors: ${failed} · total: ${total}`,
      empty: "No files added yet.",
      statusPending: "queued",
      statusUploading: "uploading",
      statusDone: "done",
      statusError: "error",
      remove: "Remove",
      allDone: (n) => `${n} videos uploaded`,
      partial: (done, failed) => `Uploaded ${done}, failed ${failed}`,
      allFailed: "None of the files uploaded",
      running: "Uploading…",
    },
    ideas: {
      trigger: "AI ideas",
      title: "AI video ideas",
      description: "AI drafts ideas tailored to the selected account's persona.",
      account: "Account (persona)",
      accountAny: "No account — generic style",
      generate: "Generate ideas",
      generating: "AI thinking…",
      empty: "No ideas yet — hit Generate.",
      close: "Close",
      use: "Create draft",
      used: "Draft created",
      failed: "AI ideas failed",
      hook: "Hook",
      caption: "Caption",
      hashtags: "Hashtags",
      duration: "Duration",
      sound: "Sound",
      seconds: (s) => `${s}s`,
    },
    fields: {
      filename: "Filename",
      sizeMb: "Size, MB",
      duration: "Duration, s",
      thumbnail: "Thumbnail URL",
      caption: "Caption",
      hashtags: "Hashtags (comma-separated)",
      sound: "Trending sound",
      account: "Target account",
    },
  },
  schedule: {
    title: "Schedule",
    description: "When and where each clip goes live. Best-time hints by geo already work.",
    add: "Schedule post",
    edit: "Edit post",
    empty: "Nothing scheduled",
    emptyHint: "Queue a post — it'll show up here.",
    markDone: "Mark as posted",
    marked: "Post marked as published",
    bestTimes: "Best time for this account",
    bestTimesPickAccount: "Pick an account — I'll show recommended slots.",
    reasons: {
      "morning scroll": "morning scroll",
      "lunch break": "lunch break",
      "commute home": "commute home",
      "prime-time couch": "prime-time couch",
      "off-peak but persona-matched": "off-peak, persona-matched",
    },
    fields: { video: "Video", account: "Account", device: "Device", when: "When" },
    status: { planned: "planned", running: "running", done: "done", failed: "failed" },
  },
  streams: {
    title: "Stream Boost",
    description: "Drop a link — accounts find it via search or For You, not the link. Watches feel human.",
    add: "New task",
    edit: "Edit task",
    empty: "No tasks yet",
    emptyHint: "Create the first — pick accounts, set randomness.",
    create: "Create task",
    start: "Start",
    stop: "Stop",
    fields: {
      url: "Stream URL",
      keywords: "Keywords (comma-separated)",
      approach: "Discovery approach",
      minWatch: "Min watch, min",
      maxWatch: "Max watch, min",
      likeProb: "Like probability",
      commentProb: "Comment probability",
      accounts: "Target accounts",
    },
    approach: { search: "Search", for_you: "For You", mixed: "Mixed (recommended)" },
  },
  warmup: {
    title: "Warm-up",
    description:
      "Every account gets a daily plan. We honour persona, rhythm, and geo quiet hours. Intensity ramps day 1 → 7.",
    tick: "Run 60m tick",
    ticking: "Executing…",
    empty: "No accounts to warm up",
    emptyHint: "Add an account and link a persona.",
    day: "Day",
    plan: "Plan",
    todaysPlan: "Today's plan",
    counters: { planned: "planned", done: "done", skipped: "skipped" },
    regen: "Regenerate plan",
    regenerated: "Plan regenerated",
    advance: "Advance a day",
    advancedTo: (day, active) => `Now on day ${day}${active ? " · promoted to ACTIVE 🎉" : ""}`,
    executed: (n, accs) => `Executed ${n} actions across ${accs} accounts`,
    todayProgress: "Today progress",
    next: (action, time) => `next ${action} at ${time}`,
    actionStatus: { planned: "planned", done: "done", skipped: "skipped" },
    markDone: "Mark done",
    skip: "Skip",
    deleted: "Action deleted",
  },
  comments: {
    title: "Auto-comments",
    description: "Drop a link → Claude writes one persona-shaped comment per account and spreads them over time.",
    new: "New blast",
    postDue: "Post due now",
    posting: "Posting…",
    empty: "Queue is empty",
    emptyHint: "Create your first blast to seed early engagement.",
    create: "Generate & queue",
    creating: "Generating…",
    fields: { url: "Target video URL", topic: "Video topic (for AI)", spread: "Spread across, min", accounts: "Accounts" },
    queued: (n) => `${n} AI comments queued`,
    posted: (n) => `Posted (mock): ${n}`,
    status: { planned: "planned", posted: "posted", skipped: "skipped" },
  },
  logs: {
    title: "Action logs",
    description: "Every swipe, like, follow, comment and pause — timestamped and traceable.",
    filter: { all: "all", info: "info", success: "success", warn: "warn", error: "error" },
    empty: "No logs",
  },
  analytics: {
    title: "Analytics",
    description: "Where the fleet is heading. Health, follower growth, shadowban risk.",
    growth30d: "Fleet growth · 30d",
    perAccountHealth: "Per-account health",
    shadowRisk: "Shadowban risk",
    noAccounts: "No accounts yet",
    risk: { low: "low", medium: "medium", high: "high" },
  },
  alerts: {
    title: "Alerts",
    description: "Captchas, bans, offline phones — anything that needs a human.",
    empty: "All clear",
    emptyHint: "No open alerts. Enjoy the calm.",
    ack: "Ack",
    acknowledged: "acknowledged",
    resolveCaptcha: "Captcha solved",
    captchaResolved: "Captcha cleared, device woken up",
    severity: { low: "low", medium: "medium", high: "high", critical: "critical" },
    type: {
      captcha: "captcha",
      ban: "ban",
      shadowban: "shadowban",
      device_offline: "device offline",
      task_failed: "task failed",
      warning: "warning",
    },
  },
  settings: {
    title: "Settings",
    description: "Providers, budgets, quiet hours, and AI connectivity check.",
    save: "Save",
    aiModels: "AI models",
    antidetect: "Antidetect defaults",
    macAgents: "Mac Agents",
    session: "Session",
    noAgents: "No Mac agent connected yet.",
    agentHint: "Grab the skeleton in /app/mac-agent/, set BACKEND_URL and PIN, run python agent.py.",
    testAi: "Test AI connectivity",
    pinging: "Pinging…",
    aiOk: (model, resp) => `OK — ${model} said "${resp}"`,
    aiError: (err) => `ERROR — ${err}`,
    fields: {
      aiProvider: "AI provider",
      claudeModel: "Claude model",
      geminiModel: "Gemini model",
      budget: "Budget, $/month",
      proxy: "Proxy provider",
      geo: "Default geo",
      quietStart: "Quiet hours start (h)",
      quietEnd: "Quiet hours end (h)",
    },
    sessionText: (envKey) =>
      `Admin PIN is loaded from server env ${envKey}. To rotate — update .env and restart backend.`,
    lastSeen: "last seen",
    devicesCount: (n) => `${n} device${n === 1 ? "" : "s"}`,
  },
  geoOptions: { US: "United States", UK: "United Kingdom" },
  languageOptions: { "en-US": "English (US)", "en-GB": "English (UK)" },
};

const dicts = { ru, en };
const stored = typeof window !== "undefined" ? window.localStorage.getItem("tta_lang") : null;
export const currentLang = stored && dicts[stored] ? stored : "ru";

export const t = dicts[currentLang];

export function setLang(lang) {
  if (!dicts[lang]) return;
  window.localStorage.setItem("tta_lang", lang);
  window.location.reload();
}

export function localizeReason(enText) {
  return t.schedule.reasons[enText] || enText;
}
